
    <router-outlet></router-outlet>
    <ng-progress></ng-progress>
    <notifier-container></notifier-container>
  